/**
 * Platform-neutrality policy — publication gate (issue #5853).
 *
 * The platform-neutrality policy is the core legal defense distinguishing a
 * permitted "prezentačný priestor" from prohibited "sprostredkovanie" (SAK
 * Advokátsky poriadok § 1 ods. 6 / § 2 ods. 3). Its DRAFT lives at
 * `docs/compliance/platform-neutrality-policy.md` and is **not authoritative
 * until @citbaj (legal) + DPO sign off** — merging the DRAFT does not ratify it
 * (CLAUDE.md compliance-doc rule).
 *
 * This module is the single source of truth for whether the *public* policy
 * page is live. It is deliberately **OFF**:
 *
 *   - When `false` (current): the public route (`/platform-neutrality` /
 *     `/neutralita-platformy`) returns `notFound()` (404) and the footer link is
 *     hidden. The scaffold ships fully reviewable but inert.
 *   - When flipped to `true` (only after sign-off): the route renders and the
 *     footer link appears.
 *
 * DRAFT — do NOT flip to `true` until the policy is signed off. Flipping this is
 * a compliance decision, not an engineering one.
 *
 * When flipping to `true`, also remove the '/platform-neutrality' entry from
 * `sitemapOnlyExcludedKeys` in `src/app/excluded-paths.ts` so the page appears
 * in sitemap.xml once it is live.
 */
export const PLATFORM_NEUTRALITY_POLICY_PUBLISHED = false as const;

/**
 * Canonical (locale-agnostic) pathname for the published policy page, matching
 * the `next-intl` `routing.pathnames` key. Localized slugs:
 *   en → /platform-neutrality
 *   sk → /neutralita-platformy
 */
export const PLATFORM_NEUTRALITY_ROUTE = '/platform-neutrality' as const;
